import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M9.7 7.8C5.2 12.4 5 14 9 14c2.8 0 2.9.1 3.2 5.7.2 4.4.7 5.8 1.8 5.8s1.6-1.4 1.8-5.8c.3-5.6.4-5.7 3.2-5.7 1.8 0 3-.5 3-1.3 0-1.2-7-8.7-8.1-8.7-.3 0-2.2 1.7-4.2 3.8zM32.4 7.1c-1 1.7 1.3 3.6 2.7 2.2C36.3 8.1 35.5 6 34 6c-.5 0-1.2.5-1.6 1.1zM32.4 15.1c-1 1.7 1.3 3.6 2.7 2.2 1.2-1.2.4-3.3-1.1-3.3-.5 0-1.2.5-1.6 1.1zM32.7 22.6c-.4.4-.7 3.1-.7 6.1 0 5.2 0 5.3-3 5.3-4.1 0-3.8 1.8 1 6.5l4 3.9 4-3.9c4.8-4.7 5.1-6.5 1-6.5-2.8 0-2.9-.1-3.2-5.7-.3-5.2-1.4-7.3-3.1-5.7zM12.4 31.1c-1 1.7 1.3 3.6 2.7 2.2 1.2-1.2.4-3.3-1.1-3.3-.5 0-1.2.5-1.6 1.1zM12.4 39.1c-1 1.7 1.3 3.6 2.7 2.2 1.2-1.2.4-3.3-1.1-3.3-.5 0-1.2.5-1.6 1.1z"
	})
});
export default SvgSort;
